module.exports = __webpack_public_path__ + "a07a606f04a7de6003f5acf82cb579af.jpg";